import { createBrowserHistory } from 'history';
import { each } from 'lodash-es';
import { objToParams, paramsToObj } from './helpers';

const history = createBrowserHistory();

/**
 * @deprecated use utilities from React Router DOM!
 */
export const _getParams = (toObject = true, prefix = '') => {
  const re = new RegExp(prefix, 'g');
  const params = window.location.search.replace(re, '');
  return toObject ? paramsToObj(params) : params;
};

/**
 * @deprecated use utilities from React Router DOM!
 */
export const _setParams = (params, prefix = '') => {
  const oldParams = _getParams(true, null);
  const _params = { ...params };
  each(_params, (val, key) => {
    // if value of new params is empty then it should be deleted
    if (val === '' || val === null) {
      delete _params[key];
      delete _params[prefix + key];
      delete oldParams[prefix + key];
    } else if (key.indexOf(prefix) !== 0) {
      _params[prefix + key] = val;
      delete _params[key];
    }
  });

  /**
   * @deprecated use utilities from React Router DOM!
   */
  const newParams = objToParams(Object.assign(oldParams, _params));

  history.replace(`${window.location.pathname}?${newParams}`);
  return params;
};

/**
 * @deprecated use utilities from React Router DOM!
 */
export const _trimParamValues = key => {
  const params = _getParams(true, key);
  for (const param in params) {
    params[param] = params[param].trim();
  }
  _setParams(params, key);
};

/**
 * @deprecated use utilities from React Router DOM!
 */
export const _clearParams = () => {
  setTimeout(() => {
    history.replace({ pathname: window.location.pathname, search: undefined });
  }, 500);
};

/**
 * @deprecated use utilities from React Router DOM!
 */
export const _deleteParams = key => {
  const params = new URLSearchParams(window.location.search);
  params.delete(key);

  const newParams = {};
  params.forEach((val, key) => {
    newParams[key] = val;
  });

  history.replace(`${window.location.pathname}?${objToParams(newParams)}`);
};
